import * as React from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import Modal from '@App/components/blocks/Modal'
import { ModalType } from '@App/store/modal'
import { ModalSize } from '@App/components/blocks/Modal/types'
import DoubleAuthenticationForm from '@App/components/forms/DoubleAuthenticationForm'
import NewProfileForm from '@App/components/forms/NewProfileForm'

const ProfileFormPage = (props: any) => {
  const { user } = props
  const [step, setStep] = React.useState(0)

  const onHandleStep = (step: number) => {
    setStep(step)
  }

  return (
    <React.Fragment>
      <section className="section">
        <h1 className="section-title" style={{ marginBottom: '20px' }}>Paramètres</h1>
        <NewProfileForm onHandleStep={onHandleStep} />
      </section>

      <Modal
        type={ModalType.FORM}
        size={ModalSize.LARGE}
      >
        <DoubleAuthenticationForm
          user={user}
          step={step}
          isDisable={user.has2FA}
        />
      </Modal>
    </React.Fragment>
  );
};

const mapStateToProps = (state: any): any => {
  const {
    user: {
      user: userState,
    },
  } = state

  return {
    user: userState,
  }
}

export default compose(
  connect(mapStateToProps),
)(ProfileFormPage)
